// Core
import React, { Component } from 'react';

// Services
import GeckoRequest from 'services/gecko-request';
import moment from 'moment';
import { renderError } from 'services/gecko-error';

// Components
import ResponseRatios from './Components/ResponseRatios';
import ResolvedConversations from './Components/ResolvedConversations';
import TimeSaved from './Components/TimeSaved';
import { GeckoDropdown, GECKO_CONSTS } from 'ui';
// Styles
import './index.scss';

export default class BotStats extends Component {
  defaultProps = {
    botId: null,
    bot: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      resolvedConversations: {
        resolvedConversations: 0,
        totalConversations: 0,
      },
      responseRatios: {
        usefulResponses: 0,
        totalResponses: 0,
      },
      timeSaved: {
        totalTimeSaved: 0,
        totalConversations: 0,
      },
      statDurationInDays: { label: 'Past 4 Weeks', value: 28 }, // 4 weeks default stats reporting.
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    this.reload();
  }

  getStartingDate = () =>
    moment()
      .startOf('day')
      .subtract(this.state.statDurationInDays.value, 'days')
      .format('YYYY-MM-DD HH:MM:SS')
      .toString();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.bot !== prevProps.bot && this.state.fetchedMisses) {
      this.reload();
    }
  }

  reload() {
    if (!this.props.botId || !Number.isInteger(this.props.botId)) {
      return;
    }

    this.fetchResponseRatios();
    this.fetchResolvedConversations();
    this.fetchTimeSaved();
  }

  fetchResponseRatios() {
    const startDate = this.getStartingDate();
    return GeckoRequest.get(
      `/bots/${this.props.botId}/stats/response-ratio?startDate=${startDate}`
    )
      .then((payload) => {
        this.setState({
          responseRatios: {
            usefulResponses: payload.successful_responses,
            totalResponses: payload.total,
          },
        });
      })
      .catch((err) => {
        renderError(err);
      });
  }

  fetchResolvedConversations() {
    const startDate = this.getStartingDate();
    return GeckoRequest.get(
      `/bots/${this.props.botId}/stats/resolved-conversations?startDate=${startDate}`
    )
      .then((payload) => {
        this.setState({
          resolvedConversations: {
            resolvedConversations: payload.resolved_conversations,
            totalConversations: payload.total,
          },
        });
      })
      .catch((err) => {
        renderError(err);
      });
  }

  fetchTimeSaved() {
    const startDate = this.getStartingDate();
    return GeckoRequest.get(
      `/bots/${this.props.botId}/stats/time-saved?startDate=${startDate}`
    )
      .then((payload) => {
        this.setState({
          timeSaved: {
            totalTimeSaved: payload.total_time_saved,
            totalConversations: payload.total_conversations,
          },
        });
      })
      .catch((err) => {
        renderError(err);
      });
  }

  updateMetrics = (timeInDays) => {
    this.setState({ statDurationInDays: timeInDays }, () => this.reload());
  };

  timeOptionsInDays = [
    {
      name: 'Today',
      handler: () => this.updateMetrics({ label: 'Today', value: 0 }),
    },
    {
      name: 'Past Week',
      handler: () => this.updateMetrics({ label: 'Past Week', value: 7 }),
    },
    {
      name: 'Past 4 Weeks',
      handler: () => this.updateMetrics({ label: 'Past 4 Weeks', value: 28 }),
    },
    {
      name: 'Past 12 Weeks',
      handler: () => this.updateMetrics({ label: 'Past 12 Weeks', value: 84 }),
    },
  ];

  render() {
    if (!this.props.botId) {
      return null;
    }

    return (
      <div className={`BotStats card gecko-card`}>
        <div className="BotStats-containerHeader gecko-card-header">
          <h2 className="header-title">
            <i className="far fa-analytics"></i>Bot Analytics
          </h2>
          <GeckoDropdown
            onToggle={() =>
              this.setState({ dropdownOpen: !this.state.dropdownOpen })
            }
            name={this.state.statDurationInDays.label}
            type={GECKO_CONSTS.BTN_TYPE_NAKED}
            size={'sm'}
            buttonConfig={{
              iconRight: this.state.dropdownOpen
                ? 'far fa-angle-up'
                : 'far fa-angle-down',
            }}
            items={this.timeOptionsInDays}
            align="right"
          />
        </div>
        <div className="BotStats-metricsList gecko-card-body">
          <div className="BotStats-metricSingleContainer">
            {ResolvedConversations(
              this.state.resolvedConversations.resolvedConversations,
              this.state.resolvedConversations.totalConversations
            )}
          </div>

          <div className="BotStats-metricSingleContainer">
            {ResponseRatios(
              this.state.responseRatios.usefulResponses,
              this.state.responseRatios.totalResponses
            )}
          </div>

          <div className="BotStats-metricSingleContainer">
            {TimeSaved(
              this.state.timeSaved.totalTimeSaved,
              this.state.timeSaved.totalConversations
            )}
          </div>
        </div>
      </div>
    );
  }
}
